import { useEffect, useState } from 'react';
import Link from 'next/link';
import { explorers } from '@shared/types/executor';
import { IoIosArrowBack } from 'react-icons/io';
import { BsSend } from 'react-icons/bs';
import { GoDownload } from 'react-icons/go';
import { useSession } from '@/contexts/LitSessionProvider';
import TransactionHashes from './TransactionHashes';
import { Button } from '@/components/ui/button';
import TransferSharedData from './TransferSharedData';
import TransferHeader from './TransferHeader';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
export default function TransactionViewTransfer({
  txItem,
  toggleModal,
  isModalOpen
}) {
  const {
    PKP
  } = useSession();
  const isMobile = useIsMobile();
  const [showTxHashes, setShowTxHashes] = useState(false);
  const solanaAddress = PKP?.solanaAddress;
  const ethAddress = PKP?.additionalEthAddress;
  const isAddressOwner = ethAddress === txItem?.to_address || solanaAddress === txItem?.to_address;
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    let timer;
    if (isModalOpen) {
      timer = setTimeout(() => setShowModal(true), 500);
    } else {
      setShowModal(false);
    }
    return () => clearTimeout(timer);
  }, [isModalOpen]);
  return <div className='w-full' data-sentry-component="TransactionViewTransfer" data-sentry-source-file="TransactionViewTransfer.tsx">
      {showTxHashes && !isMobile ? <>
          <TransactionHashes setShowTxHashes={setShowTxHashes} txItem={txItem} />{' '}
        </> : <div className='p-4'>
          <div className='w-full flex justify-between items-center h-12'>
            <div onClick={toggleModal} className='absolute cursor-pointer text-[14px] flex items-center bg-genius-blue rounded-full h-[31px] w-[74px]'>
              <IoIosArrowBack className={`ml-1 mr-2 w-[16px] text-genius-cream`} width={20} height={18} />
              <p>Back</p>
            </div>
            <div className='flex items-center ta-c w-full'>
              <div className='w-full flex justify-start ta-c'>
                <div className={`text-[16px] text-genius-cream capitalize w-full `}>
                  {isAddressOwner ? <p className='flex items-center w-full ta-c justify-center'>
                      <GoDownload className='mr-2 w-[18px] h-[18px] text-genius-cream' />
                      {txItem?.type?.replace('_', ' ').replace('withdraw', 'Received')?.toLowerCase()}
                    </p> : <p className='flex items-center w-full ta-c justify-center'>
                      <BsSend className='mr-2 w-[18px] h-[18px] text-genius-cream' />
                      {txItem?.type?.replace('_', ' ').replace('withdraw', 'Send')?.toLowerCase()}
                    </p>}
                </div>
              </div>
            </div>
          </div>

          <TransferHeader txItem={txItem} />

          <TransferSharedData txItem={txItem} isAddressOwner={isAddressOwner} />
          {showModal && <div className='w-full bg-genius-indigo mt-4'>
              <Link target='_blank' href={`${explorers[txItem?.chain_id]}/${txItem?.txn}`}>
                <Button className='rounded-full w-full mx-auto mt-1 py-2 h-[56px]' variant='pink'>
                  View Confirmation
                </Button>
              </Link>
            </div>}
        </div>}
    </div>;
}